import service from '@/util/service';

// work log
export const getWorkProjectList = params => service.jsonGet('/api/business/project/projectListForBuilderDiary', params);

export const getWorkDayList = params => service.jsonGet('/api/business/project/getMonthBuilderDiary', params);

export const getWorkLog = params => service.jsonGet('/api/business/project/getBuilderDiary', params);

export const saveWorkLog = params => service.jsonPost('/api/business/project/builderDiary', params);

export const getWeather = params => service.jsonGet('/api/business/project/weatherInfo', params);



// WEBPACK FOOTER //
// ./src/api/workLog/index.js